import React from 'react'
import { Route, Routes, useLocation } from 'react-router'
import Home from './Home'
import Skills from './Skills'
import Works from './Works'
import DetailsWork from './DetailsWork'
import { AnimatePresence } from "framer-motion";

export default function Feed() {
  return (
    <div className='feed'>
      <AnimatePresence exitBeforeEnter>
        <Routes>
          <Route path='/skills' element={ <Skills /> } />
          <Route path='/' element={ <Home /> } />
          <Route path='/work' element={ <Works /> }/> 
          <Route path='/details/:id' element={ <DetailsWork />}/> 
        </Routes>
      </AnimatePresence>  
    </div>
  )
}
